export enum DealDocumentCategory {
  AvisDImposition = 'avis_d_imposition__1_',
  FichierDPE = 'fichier_dpe',
  AuditEnergetique = 'audit_energetique',
  AuditEnergetiqueFinal = 'audit_energetique_final',
  GrilleAnalyseSynthese = 'grille_d_analyse_synthese',
  FichierDevis = 'fichier_devis',
  FichierDevis1 = 'fichier_devis__1_',
  Plans = 'plans',
  RibHi = 'rib_hi',
  JustificatifPropriete = 'justificatif_de_propriete',
  AvisVirementHi = 'avis_de_virement_hi',
  DemandeVersementAvanceHi = 'demande_de_versement_d_avance_hi',
  AttestationTravauxFacture = 'attestation_travaux__facture_',
  DevisMarSigne = 'devis_mar_signe',
  AttestationTravauxDevis = 'attestation_travaux__devis_',
  AttestationCee = 'attestation_cee',
  Factures = 'factures_hi',
  PlanDeFinancement = 'plan_de_financement___rapport_mar',
  BilanFinancier = 'plan_de_financement_previsionnel',
  RapportAccompagnement = 'rapport_d_accompagnement__cerfa_anah_',
}

const DOCUMENT_PATTERNS = [
  {
    category: DealDocumentCategory.FichierDevis,
    regex: /^(D_Travaux\d+)(\d+)?(.*)?(\d{2}-\d{2}-\d{4})/,
  },
  {
    category: DealDocumentCategory.Factures,
    regex: /^(F_Travaux\d+)(\d+)?(.*)?(\d{2}-\d{2}-\d{4})/,
  },
  {
    category: DealDocumentCategory.AvisVirementHi,
    regex: /^(Virement)(.*)?(\d{2}-\d{2}-\d{4})/,
  },
  {
    category: DealDocumentCategory.AvisDImposition,
    regex: /^(Avis d’imposition)(.*)?(\d{2}-\d{2}-\d{4})/,
  },
  {
    category: DealDocumentCategory.FichierDPE,
    regex: /^(DPE)(.*)?(\d{2}-\d{2}-\d{4})/,
  },
  {
    category: DealDocumentCategory.AuditEnergetique,
    regex: /^(Audit historique)(.*)?(\d{2}-\d{2}-\d{4})/,
  },
  {
    category: DealDocumentCategory.Plans,
    regex: /^(Plan du logement)(.*)?(\d{2}-\d{2}-\d{4})/,
  },
  {
    category: DealDocumentCategory.JustificatifPropriete,
    regex: /^(Justificatif de propriété)(.*)?(\d{2}-\d{2}-\d{4})/,
  },
  {
    category: DealDocumentCategory.RibHi,
    regex: /^(RIB)(.*)?(\d{2}-\d{2}-\d{4})/,
  },
  {
    category: DealDocumentCategory.AuditEnergetiqueFinal,
    regex: /^(Audit Hellio Ingénierie)(.*)?(\d{2}-\d{2}-\d{4})/,
  },
  {
    category: DealDocumentCategory.GrilleAnalyseSynthese,
    regex: /^(Grille d’analyse simplifiée)(.*)?(\d{2}-\d{2}-\d{4})/,
  },
  {
    category: DealDocumentCategory.AttestationTravauxFacture,
    regex: /^(Attestation de travaux - facture)(.*)?(\d{2}-\d{2}-\d{4})/,
  },
  {
    category: DealDocumentCategory.AttestationTravauxDevis,
    regex: /^(Attestation de travaux - devis)(.*)?(\d{2}-\d{2}-\d{4})/,
  },
  {
    category: DealDocumentCategory.AttestationCee,
    regex: /^(Attestation CEE)(.*)?(\d{2}-\d{2}-\d{4})/,
  },
  {
    category: DealDocumentCategory.PlanDeFinancement,
    regex: /^(Plan de financement final)(.*)?(\d{2}-\d{2}-\d{4})/,
  },
  {
    category: DealDocumentCategory.BilanFinancier,
    regex: /^(Bilan financier)(.*)?(\d{2}-\d{2}-\d{4})/,
  },
  {
    category: DealDocumentCategory.RapportAccompagnement,
    regex: /^(Rapport d’accompagnement)(.*)?(\d{2}-\d{2}-\d{4})/,
  },
  {
    category: DealDocumentCategory.DevisMarSigne,
    regex: /^(Devis MAR signé)(.*)?(\d{2}-\d{2}-\d{4})/,
  },
];

// Function to extract components
export function extractDocumentName(filename: string) {
  // return filename;
  for (const pattern of DOCUMENT_PATTERNS) {
    const match = filename.match(pattern.regex);
    if (match) {
      const values = {
        title: match[1],
        index: match[2] || null,
        date: match[4] || match[3],
      };
      return values.title.replace('CUSTOMER-', '').replace('_Client', '');
    }
  }
  return filename.replace('CUSTOMER-', '').replace('_Client', ''); // No match found
}
